import clsx from 'clsx';
import { SkeletonBlock } from './SkeletonBlock.tsx';

interface SkeletonHeadingProps {
  className?: string;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
}

export function SkeletonHeading({ className, level = 1 }: SkeletonHeadingProps) {
  return (
    <SkeletonBlock
      className={clsx(
        className,
        level === 1 && 'h-9',
        level === 2 && 'h-8',
        level === 3 && 'h-7',
        level === 4 && 'h-6',
        level === 5 && 'h-6',
        level === 6 && 'h-6'
      )}
    />
  );
}
